import React, { useState ,useEffect } from "react";
import { FaUser,FaPhone, FaEnvelope,FaShieldAlt, FaCheckCircle, FaUserCheck, FaUserTimes, FaBuilding, FaMapMarkerAlt,  FaFileInvoice, FaImage,  FaIdCard, FaFilePdf,FaSearch,FaPlus,FaTimes
} from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";
import { FaHouse } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { MdAccountBalance } from "react-icons/md";
import { MdOutlineAccountCircle } from "react-icons/md";
import { BsBank } from "react-icons/bs";
import { FaTools } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaRegIdCard } from "react-icons/fa";


function Driver({token}) {
  const navigate = useNavigate();

const [showForm, setShowForm] = useState(false);
      const [editingCompanyId, setEditingCompanyId] = useState(null);
      const [isEditMode, setIsEditMode] = useState(false);
     const[getUser,setGetUser] = useState([]);
     const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showKycModal, setShowKycModal] = useState(false);
    const [selectedDealer, setSelectedDealer] = useState(null);
      const [searchTerm, setSearchTerm] = useState('');
      const [driverDetails, setDriverDetails] = useState({});
      const [showActive, setShowActive] = useState(true);

        const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: '',
        address: '',
        buss_name: "",
        gst: '',
        profile: null,
         profilePreview: "",
       aadhaar_front:null,
        aadhaar_back:null,
        gst_doc: null,
        license:null,
      
        bank_name:'',
        ifsc_code:'',
        acc_name:'',
        acc_no:'',
        city:'',
        experience:'',
      });
    
        const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "profile") {
          setFormData({ ...formData, [name]: files[0] });
        } else {
          setFormData({ ...formData, [name]: value });
        }
      };
        const handleSubmit = async (e) => {
        }

        
const handleEdit = (form) => {

  setIsEditMode(true);
   setSelectedDealer(form);  

  setFormData({
    id: form.id || "",

    // ✅ basic dealer fields
    name: form.name || "",
    email: form.email || "",
    mobile: form.mobile || "",
    address: form.address || "",
    buss_name: form.buss_name || "",
    gst: form.gst || "",
      bank_name:form.bank_name || '',
    ifsc_code:form.ifsc_code || '',
    acc_name:form.acc_name || '',
    acc_no:form.acc_no || '',
     state:form.state || "",
     pincode:form.pincode || "",
     city:form.city || "",
     experience:form.experience || "",
     skills:form.skills || "",
   aadhaar_no:form.aadhaar_no || "",

  profile: null,
    aadhaar_front: null,
    aadhaar_back: null,
    gst_doc: null,


    profilePreview: form.profile
      ? `https://api.krimotion.in/aaUploads/${form.profile}`
      : null,

    aadhaarFrontPreview: form.aadhaar_front
      ? `https://api.krimotion.in/aaUploads/${form.aadhaar_front}`
      : null,

    aadhaarBackPreview: form.aadhaar_back
      ? `https://api.krimotion.in/aaUploads/${form.aadhaar_back}`
      : null,

          licensePreview: form.license
      ? `https://api.krimotion.in/aaUploads/${form.license}`
      : null,

    gstDocPreview: form.gst_doc
      ? `https://api.krimotion.in/aaUploads/${form.gst_doc}`
      : null,
  });

  setEditingCompanyId(form.id);
  setShowForm(true);
};


const fetchDriver = async () => {
  try {
    const res = await axios.get("https://api.krimotion.in/fetch-driver",
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;
 
    setGetUser(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchDriver();

  }, []);

 const resetForm = () => {
  setFormData({
    name: "",
    mobile: "",
    email: "",
    address: "",
    buss_name: "",
    gst: "",
     city:'',
        experience:'',

    profile: null,
    aadhaar_front: null,
    aadhaar_back: null,
    gst_doc: null,

    // ✅ IMPORTANT: reset previews also
    profilePreview: null,
    aadhaarFrontPreview: null,
    aadhaarBackPreview: null,
    licensePreview:null,
    gstDocPreview: null,
  });

  setIsEditMode(false);
  setEditingCompanyId(null);
}; 



const handleStatusUpdate = async (user) => {
  try {
    const currentStatus = user.is_active;
    const newStatus = currentStatus === '1' ? '0' : '1';

    await axios.put(
      `https://api.krimotion.in/update-driver-status/${user.id}`,
      {
        is_active: newStatus,
      },
       {
          headers: {
             Authorization: `Bearer ${token}`,
          },
        }
    );

    toast.success("Status updated successfully!");

    setShowStatusModal(false);
  fetchDriver(); 

  } catch (error) {
    console.log(error);
    toast.error("Failed to update status");
  }
};

const handleKycVerify = async (dealer) => {
  try {
    await axios.put(
      `https://api.krimotion.in/verify-driver-kyc/${dealer.id}`,
      {
        is_verify: '1',
      },
       {
          headers: {
             Authorization: `Bearer ${token}`,
          },
        }
    );

    toast.success("KYC Verified Successfully!");

    setShowKycModal(false);
    fetchDriver();

  } catch (error) {
    console.log(error);
    toast.error("KYC verification failed");
  }
};

 const handlePreviewImage = (url, file) => {
  if (file) {
    // preview newly selected file
    const previewUrl = URL.createObjectURL(file);
    window.open(previewUrl, "_blank");
  } else if (url) {
    // preview existing image
    window.open(url, "_blank");
  }
};


  // const filteredData = Array.isArray(getUser)
  //   ? getUser.filter(itm =>
  //     Object.values(itm).some(val =>
  //       String(val).toLowerCase().includes(searchTerm.toLowerCase())
  //     )
  //   )
  //   : [];

    const filteredData = Array.isArray(getUser)
  ? getUser.filter((itm) => {
      const matchesSearch = Object.values(itm).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      );

      const matchesStatus = showActive
        ? Number(itm.is_active) === 1
        : Number(itm.is_active) === 0;

      return matchesSearch && matchesStatus;
    })
  : [];


  return (
 
<>
 <div className="container py-4">

    <div className="border-0  mb-3 px-2 py-2  ">
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div className="d-flex align-items-center">
          <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
            Manage Driver
          </h4>
        </div>
    
        {/* CENTER SEARCH */}
    <div style={{ flex: 1, maxWidth: "250px" }}>
      <div
        className="d-flex align-items-center rounded-pill overflow-hidden"
        style={{
          border: "1px solid var(--green)",
          height: "34px",
          paddingLeft: "8px",
          paddingRight: "8px",
          backgroundColor:'white'
        }}
      >
        {/* ICON */}
        <FaSearch
          style={{
            color: "var(--green)",
            fontSize: "14px",
            display: "flex",
            alignItems: "center"
          }}
        />
    
        {/* INPUT */}
        <input
          type="text"
          className="form-control border-0 shadow-none"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            fontSize: "14px",
            height: "32px",
            marginLeft: "6px",
            lineHeight: "32px"
          }}
        />
      </div>
    </div>
    
     
    
      </div>
    </div>


  {showForm && (
        <div className="card shadow-sm border-0 rounded-4 p-3">

<form onSubmit={handleSubmit}> 
  <div className="row g-3">


  <div className="col-md-4">
    <label className="form-label fw-semibold">Full Name</label>
    <div className="input-group">
      <span className="input-group-text">
        <FaUser />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Full Name"
          name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  disabled
      />
    </div>
  </div>

  {/* Phone Number */}
  <div className="col-md-4">
    <label className="form-label fw-semibold">Phone Number</label>
    <div className="input-group">
      <span className="input-group-text">
        <FaPhone />
      </span>
      <input
        type="tel"
        className="form-control"
        placeholder="Enter Phone Number"
          name="mobile"
                  value={formData.mobile}
                  onChange={handleInputChange}
                    required
                      disabled
      />
    </div>
  </div>

  {/* Email */}
  <div className="col-md-4">
    <label className="form-label fw-semibold">Email </label>
    <div className="input-group">
      <span className="input-group-text">
        <FaEnvelope />
      </span>
      <input
        type="email"
        className="form-control"
        placeholder="Enter Email "
       name="email"
                  value={formData.email}
                  onChange={handleInputChange}  
                    required 
                      disabled
      />
    </div>
  </div>




  {/* Address */}
  <div className="col-md-4">
    <label className="form-label fw-semibold">Address</label>
    <div className="input-group">
      <span className="input-group-text">
        <FaHouse />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Address"
         name="address"
                  value={formData.address}
                  onChange={handleInputChange} 
                    required
                      disabled
      />
    </div>
  </div>

   <div className="col-md-4">
    <label className="form-label fw-semibold">State</label>
    <div className="input-group">
      <span className="input-group-text">
        <FaMapMarkerAlt />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter State"
         name="state"
                  value={formData.state}
                  onChange={handleInputChange} 
                    required
                      disabled
      />
    </div>
  </div>

    <div className="col-md-4">
    <label className="form-label fw-semibold">City</label>
    <div className="input-group">
      <span className="input-group-text">
        <MdLocationCity />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter City"
         name="state"
                  value={formData.city}
                  onChange={handleInputChange} 
                    required
                      disabled
      />
    </div>
  </div>

   <div className="col-md-4">
    <label className="form-label fw-semibold">Pincode</label>
    <div className="input-group">
      <span className="input-group-text">
        <FaMapMarkerAlt />
      </span>
      <input
        type="number"
        className="form-control"
        placeholder="Enter Pincode"
         name="pincode"
                  value={formData.pincode}
                  onChange={handleInputChange} 
                    required
                      disabled
      />
    </div>
  </div>


  <div className="col-md-4">
      <label className="form-label fw-semibold">Aadhaar No.</label>
      <div className="input-group">
        <span className="input-group-text">
          <FaRegIdCard  />
        </span>
        <input
          type="number"
          className="form-control"
          placeholder="Enter Aadhaar No"
           name="aadhaar_no"
                    value={formData.aadhaar_no}
                    onChange={handleInputChange} 
                      required
                        disabled
        />
      </div>
    </div>

<div className="col-md-4">
    <label className="form-label fw-semibold">Experience</label>
    <div className="input-group">
      <span className="input-group-text">
        <GrUserManager />
      </span>
      <input
        type="number"
        className="form-control"
        placeholder="Enter Experience"
         name="experience"
                  value={formData.experience}
                  onChange={handleInputChange} 
                    required
                      disabled
      />
    </div>
  </div>

  
  <hr/>

   <div className="col-md-4">
    <label className="form-label fw-semibold">Account Holder Name</label>
    <div className="input-group">
      <span className="input-group-text">
       <MdOutlineAccountCircle />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Account Holder Name"
          name="acc_name"
                  value={formData.acc_name}
                  onChange={handleInputChange}
                    disabled
      />
    </div>
  </div>

   <div className="col-md-4">
    <label className="form-label fw-semibold">Account No.</label>
    <div className="input-group">
      <span className="input-group-text">
     <MdAccountBalance />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Account Number"
          name="acc_no"
                  value={formData.acc_no}
                  onChange={handleInputChange}
                    disabled
      />
    </div>
  </div>
   <div className="col-md-4">
    <label className="form-label fw-semibold">IFSC Code</label>
    <div className="input-group">
      <span className="input-group-text">
        <FaFileInvoice />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter IFSC Code"
          name="ifsc_code"
                  value={formData.ifsc_code}
                  onChange={handleInputChange}
                    disabled
      />
    </div>
  </div>
   <div className="col-md-4">
    <label className="form-label fw-semibold">Bank Name</label>
    <div className="input-group">
      <span className="input-group-text">
        <BsBank />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Bank Name"
          name="bank_name"
                  value={formData.bank_name}
                  onChange={handleInputChange}
                    disabled
      />
    </div>
  </div>


  <div className="col-md-4">
    <label className="form-label fw-semibold">
      <FaImage className="me-2" />
      Upload Image
    </label>
    <input
      type="file"
      className="form-control"
      accept="image/*"
      name="profile"
      onChange={(e) =>
                    setFormData({ ...formData, profile: e.target.files[0] })
                  }
                    disabled
                 
    />
      {isEditMode && formData.profilePreview && (
    <div className="ms-2 align-content-center mt-1">
      <button
        type="button"
        className="btn-action btn-primary-custom"
        onClick={() =>
          handlePreviewImage(formData.profilePreview, formData.profile)
        }
      >
        Preview
      </button>
    </div>
  )}
  </div>

  <div className="col-md-4">
    <label className="form-label fw-semibold">
      <FaIdCard className="me-2" />
      Aadhaar Front
    </label>
 
    <input
      type="file"
      className="form-control"
      accept="image/*"
        name="aadhaar_front"
      onChange={(e) =>
                    setFormData({ ...formData, aadhaar_front: e.target.files[0] })
                  }
                    disabled
                    
    />

       { isEditMode && formData.aadhaarFrontPreview && (
  <div className="mb-2 mt-1">
   
     <button
        type="button"
        className="btn-action btn-primary-custom"
        onClick={() =>
          handlePreviewImage(formData.aadhaarFrontPreview, formData.aadhaar_front)
        }
      >
        Preview
      </button>
  </div>
)}
  </div>


  <div className="col-md-4">
    <label className="form-label fw-semibold">
      <FaIdCard className="me-2" />
      Aadhaar Back
    </label>
    <input
      type="file"
      className="form-control"
      accept="image/*"
            name="aadhaar_back"
      onChange={(e) =>
                    setFormData({ ...formData, aadhaar_back: e.target.files[0] })
                  }
                    disabled
                 
    />
       { isEditMode && formData.aadhaarBackPreview && (
  <div className="mb-2 mt-2">
   
     <button
        type="button"
        className="btn-action btn-primary-custom"
        onClick={() =>
          handlePreviewImage(formData.aadhaarBackPreview, formData.aadhaar_back)
        }
      >
        Preview
      </button>
  </div>
)}
  </div>

  <div className="col-md-4">
    <label className="form-label fw-semibold">
      <FaIdCard className="me-2" />
License
    </label>
    <input
      type="file"
      className="form-control"
      accept="image/*"
            name="license"
      onChange={(e) =>
                    setFormData({ ...formData, license: e.target.files[0] })
                  }
                    disabled
                 
    />
       { isEditMode && formData.licensePreview && (
  <div className="mb-2 mt-2">
   
     <button
        type="button"
        className="btn-action btn-primary-custom"
        onClick={() =>
          handlePreviewImage(formData.licensePreview, formData.license)
        }
      >
        Preview
      </button>
  </div>
)}
  </div>


<div className="col-md-8">
  <label className="form-label fw-semibold">
    <FaTools className="me-2" />
    Skills
  </label>

  <div className="border rounded p-3 bg-light">
    <div className="d-flex flex-wrap gap-2">
      {selectedDealer?.skills ? (
        selectedDealer.skills.split(",").map((skill, index) => (
          <span key={index} className="badge bg-primary px-3 py-2">
            {skill.trim()}
          </span>
        ))
      ) : (
        <span className="text-muted">No skills available</span>
      )}
    </div>
  </div>
</div>


  <div className="col-12 text-end">
    {/* <button type="submit" className="btn btn-success">
     {isEditMode ? "Update Dealer" : " Save Dealer"}
    </button> */}

    <button className="btn-action btn-danger-custom"  onClick={() => {
            resetForm();
            setShowForm(false);
          }} > Cancel</button>
  </div>

</div>
</form>
        </div>
      )}


           {/* {!showForm && (
             <>
             
           
    
         <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9'}}>
     
           <div className="card-body p-3">
                    <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead  >
              <tr>
              
                <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Full Name</th>
                <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Phone</th>
                <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Email</th>
           
               
                <th className=" text-white" style={{backgroundColor:'var(--green)'}}>Verify KYC </th>
                  <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Wallet</th>
                                  <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Rating</th>
                <th className=" text-center text-white" style={{backgroundColor:'var(--green)'}}>Actions</th>
               
              </tr>
            </thead>
    
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((dealer, index) => (
                  <tr key={index}>
                 
    
                    <td>{dealer.name}</td>
    
                    <td>{dealer.mobile}</td>
    
                    <td>{dealer.email}</td>
<td>
  <span
    className={`status-badge ${
      Number(dealer.is_verify) === 1
        ? "status-success"
        : "status-warning"
    }`}
    style={{
      cursor: Number(dealer.is_verify) === 1 ? "default" : "pointer",
      userSelect: "none",
    }}
    onClick={() => {
      if (Number(dealer.is_verify) !== 1) {
        setSelectedDealer(dealer);
        setShowKycModal(true);
      }
    }}
  >
    {Number(dealer.is_verify) === 1 ? (
      <>
        <i className="bi bi-patch-check-fill me-1"></i>
        Verified
      </>
    ) : (
      <>
        <i className="bi bi-shield-check me-1"></i>
        Verify KYC
      </>
    )}
  </span>
</td>

            
<td>
  {dealer.wallet||  "-"}
</td>

<td>
  <button
    className="btn-action btn-warning-custom"
    onClick={() =>
      navigate("/admin/rating", {
        state: {
          dealer: dealer,
          given_to_type: "Driver"
        },
      })
    }
  >
    {dealer.avg_rating}
  </button>
</td>
<td className="text-center">
  <div className="d-flex justify-content-center align-items-center gap-2">
    <button
      className="btn-action btn-primary-custom"
      onClick={() => handleEdit(dealer)}
    >
      <i className="bi bi-pencil me-1"></i>
      View
    </button>

    <button
      className={`btn-action ${
        Number(dealer.is_active) === 1
          ? "btn-success-custom"
          : "btn-danger-custom"
      }`}
      onClick={() => {
        setSelectedUser(dealer);
        setShowStatusModal(true);
      }}
    >
      {Number(dealer.is_active) === 1 ? (
        <>
          <i className="bi bi-check-circle me-1"></i>
          Active
        </>
      ) : (
        <>
          <i className="bi bi-x-circle me-1"></i>
          Inactive
        </>
      )}
    </button>
  </div>
</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    No Dealers Found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
           </div> 
    
     

      </div>
    
        </>
             )} */}

{!showForm && (

  <>
     <div className="d-flex justify-content-end mb-3">
  <div
    className="d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      gap: "4px",
    }}
  >
    <span
      className={`fw-semibold ${
        showActive ? "text-success" : "text-danger"
      }`}
      style={{ minWidth: "100px" }}
    >
      {showActive ? "Active " : "Deactivated "}
    </span>

    <div className="form-check form-switch m-0">
      <input
        className="form-check-input"
        type="checkbox"
        checked={!showActive}
        onChange={() => setShowActive(!showActive)}
        style={{
          width: "3rem",
          height: "1.5rem",
          cursor: "pointer",
        }}
      />
    </div>
  </div>
</div>
             <div className="container-fluid mt-4">
  <div className="row g-4">

    {filteredData.map((user) => (
      <div className="col-xl-4 col-lg-4 col-md-6" key={user.id}>
        <div className="user-card h-100">
      
      
          {/* Header */}
         <div className="d-flex justify-content-between align-items-center mb-3">

  <div className="d-flex align-items-center">
    <img
      src={
        user.profile
          ? `https://api.krimotion.in/aUploads/${user.profile}`
          : "https://ui-avatars.com/api/?name=" +
            encodeURIComponent(user.name)
      }
      alt={user.name}
      className="user-img"
    />

    <div className="ms-1">
      <h5 className="mb-0 fw-bold">{user.name}</h5>
    </div>
  </div>



</div>

          {/* Details */}

          <div className="mb-2">
            <small className="text-muted">Email</small>
            <div>{user.email}</div>
          </div>

          <div className="mb-2">
            <small className="text-muted">Phone</small>
            <div>{user.mobile}</div>
          </div>

     <div className="d-flex justify-content-between align-items-center mb-3">

  {/* KYC */}
  <div>
    <small className="text-muted d-block">Verify KYC</small>

    <span
      className={`status-badge ${
        Number(user.is_verify) === 1
          ? "status-success"
          : "status-warning"
      }`}
      style={{
        cursor: Number(user.is_verify) === 1 ? "default" : "pointer",
        userSelect: "none",
      }}
      onClick={() => {
        if (Number(user.is_verify) !== 1) {
          setSelectedDealer(user);
          setShowKycModal(true);
        }
      }}
    >
      {Number(user.is_verify) === 1 ? (
        <>
          <i className="bi bi-patch-check-fill me-1"></i>
          Verified
        </>
      ) : (
        <>
          <i className="bi bi-shield-check me-1"></i>
          Verify KYC
        </>
      )}
    </span>
  </div>


  <div className="text-end mt-3">
    <small className="text-muted d-block"></small>

    <button
      className="btn-action btn-warning-custom rounded-pill px-3"
      onClick={() =>
        navigate("/admin/rating", {
          state: {
            dealer: user,
            given_to_type: "Driver",
          },
        })
      }
    >
      ⭐ {Number(user.avg_rating || 0).toFixed(1)}
    </button>
  </div>

</div>


          {/* Buttons */}

          <div className="mt-4 d-flex justify-content-between gap-2">

             <button
      className={`btn-action ${
        Number(user.is_active) === 1
          ? "btn-success-custom"
          : "btn-danger-custom"
      }`}
      onClick={() => {
        setSelectedUser(user);
        setShowStatusModal(true);
      }}
    >
      {Number(user.is_active) === 1 ? (
        <>
          <i className="bi bi-check-circle me-1"></i>
          Active
        </>
      ) : (
        <>
          <i className="bi bi-x-circle me-1"></i>
          Inactive
        </>
      )}
    </button>

            <button
              className="btn-action btn-primary-custom "
              onClick={() => handleEdit(user)}
            >
              Details
            </button>

                 <button
              className="btn-action btn-action btn-warning-custom "
              onClick={() =>
        navigate("/admin/activity", {
          state: {
            dealer: user,
            user_type:'driver'
          },
        })
      }
            >
          View Activity
            </button>

          </div>

        </div>
      </div>
    ))}

  </div>
</div>
</>
  )}

              {showStatusModal && (
      <div
        className="modal d-block"
        style={{
          background: "rgba(0,0,0,0.55)",
          backdropFilter: "blur(4px)",
          zIndex: 9999,
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content border-0 shadow-lg"
            style={{ borderRadius: "18px", overflow: "hidden" }}
          >
       
            <div
              className="text-center py-4"
              style={{
                background:
                  selectedUser?.is_active == 1
                    ? "linear-gradient(135deg,#16a34a,#22c55e)"
                    : "linear-gradient(135deg,#dc3545,#ef4444)",
              }}
            >
              <div
                className="mx-auto d-flex align-items-center justify-content-center"
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.2)",
                }}
              >
                {selectedUser?.is_active == 1 ? (
                  <FaUserTimes size={34} color="#fff" />
                ) : (
                  <FaUserCheck size={34} color="#fff" />
                )}
              </div>
    
              <h4 className="text-white fw-bold mt-3 mb-0">
               
               
                {selectedUser?.is_active == 1
                  ? "Deactivate Driver"
                  : "Activate Dealer"}
              </h4>
            </div>
    
     
            <div className="p-4 text-center">
    
              <h5 className="fw-bold mb-2">
                {selectedUser?.name}
              </h5>
    
              <p className="text-muted mb-4">
                Are you sure you want to{" "}
                <strong>
                  {selectedUser?.is_active == 1
                    ? "deactivate"
                    : "activate"}
                </strong>{" "}
                this driver?
              </p>
    
              <div
                className="d-inline-flex align-items-center px-4 py-2 rounded-pill"
                style={{
                  background:
                    selectedUser?.is_active == 1
                      ? "#d1fae5"
                      : "#fee2e2",
                }}
              >
                <span className="me-2 fw-semibold text-dark">
                  Current Status
                </span>
    
                <span
                  className={`badge ${
                    selectedUser?.is_active == 1
                      ? "bg-success"
                      : "bg-danger"
                  }`}
                >
                  {selectedUser?.is_active == 1
                    ? "Active"
                    : "Inactive"}
                </span>
              </div>
    
            </div>
    
   
            <div className="px-4 pb-4 d-flex gap-3">
    
              <button
                className="btn btn-light border w-50"
                style={{ borderRadius: "10px" }}
                onClick={() => setShowStatusModal(false)}
              >
                Cancel
              </button>
    
              <button
                className={`btn w-50 ${
                  selectedUser?.is_active == 1
                    ? "btn-danger"
                    : "btn-success"
                }`}
                style={{
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                onClick={() => handleStatusUpdate(selectedUser)}
              >
                {selectedUser?.is_active == 1
                  ? "Deactivate"
                  : "Activate"}
              </button>
    
            </div>
          </div>
        </div>
      </div>
    )} 
    

 {showKycModal && (
      <div
        className="modal d-block"
        style={{
          background: "rgba(0,0,0,0.55)",
          backdropFilter: "blur(4px)",
          zIndex: 9999,
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content border-0 shadow-lg"
            style={{
              borderRadius: "18px",
              overflow: "hidden",
            }}
          >
       
            <div
              className="text-center py-4"
              style={{
                background:
                  "linear-gradient(135deg, var(--green), #22c55e)",
              }}
            >
              <div
                className="mx-auto d-flex align-items-center justify-content-center"
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.2)",
                }}
              >
                <FaShieldAlt size={34} color="#fff" />
              </div>
    
              <h4 className="text-white fw-bold mt-3 mb-0">
                KYC Verification
              </h4>
            </div>
    
      
            <div className="p-4 text-center">
    
              <div className="mb-3">
                <FaCheckCircle
                  size={45}
                  color="var(--green)"
                />
              </div>
    
              <h5 className="fw-bold">
                Verify Dealer KYC?
              </h5>
    
              <p className="text-muted mb-4">
                You are about to verify the KYC documents for this driver.
              </p>
    
              <div
                className="rounded-4 p-3"
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #e9ecef",
                }}
              >
                <h6 className="fw-bold mb-1">
                  {selectedDealer?.name}
                </h6>
    
               
              </div>
    
              <div
                className="alert alert-warning mt-4 mb-0"
                style={{
                  borderRadius: "12px",
                  fontSize: "14px",
                }}
              >
                Once verified, the driver's KYC status will be marked as
                <strong> Verified</strong>.
              </div>
    
            </div>
    

            <div className="px-4 pb-4 d-flex gap-3">
    
              <button
                className="btn btn-light border w-50"
                style={{
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                onClick={() => setShowKycModal(false)}
              >
                Cancel
              </button>
    
              <button
                className="btn w-50"
                style={{
                  background: "var(--green)",
                  color: "#fff",
                  borderRadius: "10px",
                  fontWeight: 600,
                }}
                onClick={() => handleKycVerify(selectedDealer)}
              >
                Verify KYC
              </button>
    
            </div>
          </div>
        </div>
      </div>
    )} 
    
 </div>
 </>
  )
}

export default Driver
